module.exports = __webpack_public_path__ + "img/14.abcc79d8.jpg";